import React from "react";
import { SvgIcon } from "../SvgIcon/SvgIcon";

interface LogotypeProps {
  logoUrl?: string;
}

export const Logotype: React.FC<LogotypeProps> = ({ logoUrl }) => {
  return (
    <a className="logo navbar-brand py-1" href="/" aria-label={logoUrl ? "Volvat forside" : ""}>
      {logoUrl ? (
        <img className="logo__graphic__img" src={logoUrl} alt="" />
      ) : (
        <span className="logo__graphic">
          <SvgIcon iconName="logotype" />
        </span>
      )}
    </a>
  );
};
